//import React, {ChangeEvent, useState, useEffect} from "react";
//import React from "react";
import React, {useState, useEffect} from "react";
import "../Common/common.scss";
import './message.scss';
import * as microsoftTeams from "@microsoft/teams-js";
interface Props {
    
}

const AdminConsent: React.FC<Props> = (props) => {
    const [authenticaiotnbuttonclicked, setauthenticaiotnbuttonclicked] = useState<boolean>(false);
    useEffect(() => {
        console.log(`image changed: ${authenticaiotnbuttonclicked}`);
    }, [authenticaiotnbuttonclicked]);

    const Authenticate=(url)=> {
        
        
        var successCallback=(data)=> {
           window.location.reload();
           microsoftTeams.authentication.notifySuccess();
        };
        var failureCallback=(error)=> {
            microsoftTeams.authentication.notifyFailure();
        };
        microsoftTeams.authentication.authenticate({url: url, 
            width: 400, 
            height: 700,
            successCallback: successCallback,
            failureCallback: failureCallback
        });
        setauthenticaiotnbuttonclicked(true);
      }
      if(authenticaiotnbuttonclicked){
        return (
          <div  
            className="text-center"
            style={{
              backgroundColor: "#fff",
              color: "black",
              padding: "20px"
            }}>
                After admin consent done, Please refresh the tab.
          </div>
        );
      }
    return (
        <div className="mesagecontainer">
            <b style={{color:'red'}}>MIPA requires Admin Consent.</b>
            <p>
            Using the Microsoft 365 tenant Global Administration Account, please click on following button to grant admin consent to set the required Microsoft Graph permission. Notice, a pop up will open showing the required permissions for using the Graph API. This permission is NOT given to iGlobe, but for your users on your tenant. Click on Accept to give Admin consent.
            </p>
            <p>If you are not a Global Administrator. Please ask an admin to grant permission to this app before you can use it.</p>
            <div className='ms-Grid-col ms-sm12 ms-md12 ms-lg12' style={{ paddingTop: 20 }}>
                            <a style={{cursor:'pointer'}} className='ms-Button ms-Button--default viewswitchbtn adminconsent'
                            onClick={()=> {Authenticate('https://login.microsoftonline.com/common/oauth2/authorize?IsDlg=1&client_id=e854ea05-68ab-4204-babe-db4a784fb4d8&scope=Web.Read%20List.Manage&response_type=code&redirect_uri=https%3A%2F%2Fmipaapp.iglobe.dk%2FAuth&state=onlyconsent&prompt=admin_consent');}}
                             //href='https://login.microsoftonline.com/common/oauth2/authorize?IsDlg=1&client_id=e854ea05-68ab-4204-babe-db4a784fb4d8&scope=Web.Read%20List.Manage&response_type=code&redirect_uri=https%3A%2F%2Fmipaapp.iglobe.dk%2FAuth&state=onlyconsent&prompt=admin_consent'
                                target="_blank"  >Admin Consent</a>
            </div>
            <p style={{marginTop:100}}>
                <div>
                To help you understand Global admin consent and permission in the Microsoft identity platform, we can refer you to the following documentation from Microsoft
                </div>
                <ol>
                    <li>Understanding Azure AD application consent experiences <a href="https://docs.microsoft.com/en-us/azure/active-directory/develop/application-consent-experience" target='_blank'>use this link</a> </li>
                    <li>Permissions and consent in the Microsoft identity platform <a href="https://docs.microsoft.com/en-us/azure/active-directory/develop/v2-permissions-and-consent" target="_blank"> use this link</a> </li>
                </ol>
            </p>
            <p>Should you have any questions please feel free to <a href="mailto:sales@iglobe.dk" target="_blank" rel="noopener">contact us</a>. We can also offer you a demo or assist you in the implementation. As it is a simple product, we believe it will not take more than just 30 min. <a href="https://outlook.office365.com/owa/calendar/iGlobeOffice365@iglobe.dk/bookings/" target="_blank" rel="noopener">Book us now</a></p>

            <b>NB: After given consent please reload the app.</b>
        </div>
    )

    
};

export default AdminConsent;